import { refreshConsentMaps } from "./_cookie-consent";

document.querySelectorAll("[data-location-details]").forEach((section) => {
  const map = section.querySelector("[data-location-map]");
  const frame = map?.querySelector("iframe");
  if (!frame) return;

  function showMap(source) {
    const url = source.dataset.mapUrl;
    frame.dataset.consentSrc = url || "";
    map.hidden = !url;
    section.classList.toggle("location-details--with-map", Boolean(url));
    if (!url) {
      frame.removeAttribute("src");
      return;
    }
    frame.title = source.dataset.mapTitle || "Google Maps";
    refreshConsentMaps();
  }

  section.addEventListener("show.bs.collapse", (event) => {
    if (event.target.matches("[data-location-panel]")) showMap(event.target);
  });

  section.addEventListener("click", (event) => {
    const button = event.target.closest("[data-location-map-select]");
    if (button) showMap(button);
  });
});
